import type {InputHTMLAttributes} from "react";

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export function Field({label, error, id, ...input}: FieldProps) {
  const fieldId = id ?? input.name;
  const errorId = error && fieldId ? `${fieldId}-error` : undefined;
  return (
    <label className="field" htmlFor={fieldId}>
      <span>{label}</span>
      <input {...input} id={fieldId} aria-invalid={Boolean(error)} aria-describedby={errorId} />
      {error && <small className="field-error" id={errorId}>{error}</small>}
    </label>
  );
}
